import { PORTAL_NAME_MODAL_DEFINE } from 'components/common/PortalModal/config';
import {
  FX_EMAIL,
  FX_PHONE,
  FX_TRANSACTIONS_PREFIX,
  ORDER_EMAIL,
  STATUS_SUBMITTED,
  STATUS_UNPAID,
} from 'constants';
import Cookies from 'helpers/cookies';
import useFxAddTransaction, {
  FX_MAKE_PAYMENT_KEY,
} from 'hooks/fx/useFxAddTransaction';
import useFxFormAddTransactionStore from 'hooks/fx/useFxFormAddTransactionStore';
import useLang from 'hooks/useLang';
import usePortalModal from 'hooks/usePortalModal';
import useTheme from 'hooks/useTheme';
import { isEmpty } from 'lodash';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { stringUtils } from 'utils';

const withAllowOrderMakePayment = (Component) => {
  const AllowOrderMakePaymentComponent = (props) => {
    const { isHHMTTheme } = useTheme();
    const { t } = useLang();
    const { showPortalModalName, closePortalModalName } = usePortalModal();
    const navigate = useNavigate();

    const [isAllowOrderMakePayment, setAllowOrderMakePayment] = useState(true);

    const {
      transactionDetails,
      redirectToForeignExhangePath,
      isShowPaymentInstruction,
      resetAddTransactionInformation,
      setAddTransactionCurrentStep,
      setTransactionDetails,
      resetDenomination,
      resetNotes,
    } = useFxFormAddTransactionStore();
    const { isFxAsGuest } = useFxAddTransaction();

    const onAllowOrderMakePayment = (transactionDetails) => {
      const isAllowOrderMakePayment =
        transactionDetails?.paymentStatus === STATUS_UNPAID &&
        transactionDetails?.orderStatus === STATUS_SUBMITTED;
      if (!isAllowOrderMakePayment) {
        showPortalModalName({
          name: PORTAL_NAME_MODAL_DEFINE.FX_DISALLOW_ORDER_MAKE_PAYMENT_MODAL,
          content: stringUtils.replaceKeyword(
            t('popup_make_payment_cancelled'),
            [
              { key: 'email', value: FX_EMAIL },
              { key: 'phone', value: FX_PHONE },
            ]
          ),
          action: () => {
            Cookies.remove(FX_MAKE_PAYMENT_KEY);
            Cookies.remove(ORDER_EMAIL);
            resetAddTransactionInformation();
            setAddTransactionCurrentStep(0);
            setTransactionDetails(null);
            resetDenomination();
            resetNotes();
            if (isFxAsGuest) {
              redirectToForeignExhangePath();
              return;
            }
            navigate(FX_TRANSACTIONS_PREFIX);
            closePortalModalName();
          },
        });
      }
      if (isShowPaymentInstruction) {
        setAllowOrderMakePayment(true);
      } else {
        setAllowOrderMakePayment(false);
      }
    };

    useEffect(() => {
      if (isEmpty(transactionDetails)) return;
      onAllowOrderMakePayment(transactionDetails);
    }, [transactionDetails]);

    const newProps = {
      ...props,
      isAllowOrderMakePayment,
    };
    return <Component {...newProps} />;
  };
  return AllowOrderMakePaymentComponent;
};

export default withAllowOrderMakePayment;
